<template>
    <div class="section-list-container" :class="{'mobile-section-list-container':isMobile}">
        <div class="course-section clear-float" v-for="(section,sectionNum) in courseInfo.sections" :key="section.sectionId">
            <h3>
                <div style="flex: 1;">
                    {{sectionNum+1}}. <span style="margin-left: 4px">
                      {{section.sectionName}}
                    </span>
                </div>

                <div class="section-down">
                    <span @click="toDownFile(section.sectionId)">
                         <a-tag color="#2db7f5"> <a-icon type="cloud-download"/>下载</a-tag>
                    </span>
                </div>

            </h3>

            <dl>
                <dt v-for="(subsection,subsectionNum) in section.subSections" :key="subsection.sectionId"
                    :class="{'active-section':isCoursePlay && selectedSection.sectionId===subsection.sectionId}"
                    @click="mobilePlay(subsection.sectionId,subsection.canTry )"
                >
                    <div class="section-title">
                        {{sectionNum+1}}-{{subsectionNum+1}} <span style="display: inline-block;width: 8px"></span>{{subsection.sectionName}}
                    </div>

                    <div v-if="getPlayText(subsection)" class="section-action">
                        <span v-if="!isMobile" @click="playVideo(subsection.sectionId,subsection.canTry )">
                             <span class="play-icon">
                                 <a-icon v-if="subsection.sectionStudyStatus == 0 " type="play-circle"/>
                                 <a-icon v-else-if="subsection.sectionStudyStatus == 1" style="color: #1890ff"
                                         type="clock-circle"/>
                                 <a-icon v-else-if="subsection.sectionStudyStatus == 2" style="color: #00CF8C"
                                         type="check-circle"/>
                                  <a-icon v-else type="play-circle"/>
                             </span>
                            <span class="play-text"> {{getPlayText(subsection)}}  </span>
                        </span>

                        <span v-else>     <span class="play-icon">
                                 <a-icon v-if="subsection.sectionStudyStatus == 0 " type="play-circle"/>
                                 <a-icon v-else-if="subsection.sectionStudyStatus == 1" style="color: #1890ff"
                                         type="clock-circle"/>
                                 <a-icon v-else-if="subsection.sectionStudyStatus == 2" style="color: #00CF8C"
                                         type="check-circle"/>
                                 <a-icon v-else type="play-circle"/>
                             </span>
                        </span>
                    </div>
                </dt>
            </dl>
        </div>
        <!-- 下载文件模态框-->
        <a-modal title="文件下载" v-model="showDown" @ok="handleOk" :footer="null">
            <p class="down-file-p clear-float" v-for="item in fileList" :key=item.fileId>
                        <span class="item-fileName" :title="item.fileName">
                            {{item.fileName}}
                        </span>
                <span class="item-down" @click="downFile(item)">
                        <a-icon type="download"/>
                        </span>
            </p>
        </a-modal>
    </div>
</template>

<script>
    import {createNamespacedHelpers} from "vuex";
    import common from "../../../mixin/common";
    import {DISPATCH_SWITCH_SECTION} from "@constants/action-type/course-action-type";
    import {getSectionFile} from "@api/courese-detail"
    import {showError, showWaringMsg} from "@utils/msg";
    const {mapState} = createNamespacedHelpers('course');

    export default {
        name: "SectionList",
        data() {
            return {
                showDown: false,
                fileList: [],
            }
        },
        mixins: [common],
        methods: {
            mobilePlay(sectionId,canTry) {
                if (this.isMobile){
                    this.playVideo(sectionId,canTry)
                } else {
                    this.playVideo(sectionId, canTry)
                }
            },
            playVideo(sectionId, canTry) {
                // 判断是否免费
              if (this.$func.isTrue(this.courseInfo.isFree) || this.isLoginClick()){
                    // 判断是否是播放界面，如果是进行专题切换，如果不是，则跳转到课程播放界面
                    if (!this.isCoursePlay) {
                        this.$router.push({
                            name: 'courseStudy',
                            params: {courseId: this.courseInfo.courseId},
                            query: {sectionId}
                        })
                    } else {
                        const payload = {
                            sectionId,
                            canTry,
                        };
                        this.$store.dispatch(DISPATCH_SWITCH_SECTION, payload)
                    }
                }
            },
            getPlayText(section) {
                // 如果是免费显示观看
                if (this.$func.isTrue(this.courseInfo.isFree)) {
                    return '观看';
                } else if (this.isPaid) {
                    return '观看';
                } else if (this.$func.isTrue(section.canTry)) {
                    return '试看';
                } else {
                    return false;
                }
            },
            //    下载文件
            toDownFile(fatherSectionId) {
                console.log(this.courseInfo)
                //登录状态
                if (this.isLoginClick()) {
                    getSectionFile(fatherSectionId).then((res) => {
                        if (res.code === 0) {
                            if (res.canDownLoad) {
                                if (res.courseSection.fileList.length == 0) {
                                    showWaringMsg("该章节没有附属文件")
                                } else {
                                    this.fileList = res.courseSection.fileList
                                    this.showModal()
                                }
                            } else {
                                showWaringMsg("抱歉，您尚未拥有该课程，无法下载附属文件！")
                            }

                        } else {
                            showError(res.msg)
                        }

                    })
                }
            },
            downFile(item) {
                let href = item.fileUrl + `?download=${item.fileName}`;
                window.open(href, '_blank')
            },

            //    下载模态框
            showModal() {
                this.showDown = true;
            },
            handleOk(e) {
                console.log(e);
                this.showDown = false;
            },
        },
        props: {
            isCoursePlay: {
                default: false,
                type: Boolean
            }
        },
        computed: {
            ...mapState({
                selectedSection: 'selectedSection',
                courseInfo: 'courseInfo',
                isPaid: "isPaid"
            }),
        },
    }
</script>

<style scoped lang="less">
    .section-list-container {
        .play-icon {
            display: inline;
        }

        .play-text {
            display: none;
        }
        .course-section {
            h3 {
                font-size: 22px;
                padding: 5px 0px 5px 10px;
                display: flex;
                -webkit-box-pack: justify;
                justify-content: space-between;

                div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            dt:hover {
                color: #00CF8C;
                cursor: pointer;

                .play-icon {
                    display: none;
                }

                .play-text {
                    display: inline;
                }
            }
            dt {
                height: 50px;
                line-height: 30px;
                padding: 10px 20px;
                background: #F2F2F2;
                margin: 10px 0;

                .section-title {
                    float: left;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box; //作为弹性伸缩盒子模型显示。
                    -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
                    -webkit-line-clamp: 1; //显示的行
                }

                .section-action{
                    float: right;
                }

                .ant-btn {
                    height: 30px;
                }

                .anticon {
                    font-size: 16px;
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    // 移动端章节列表
    .mobile-section-list-container {
        .course-section {
            h3 {
                font-size: 16px;
                padding: 5px 0px 5px 5px;
                display: flex;
                justify-content: space-between;
                -webkit-box-pack: justify;
                align-items: center;

                div {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                .section-down {
                    font-size: 14px;
                    color: #24A5FE;
                    margin-left: 30px;

                    /deep/ .ant-tag-has-color {
                        height: 26px;
                        width: 60px;
                        font-size: 13px;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }

            dt {
                height: 35px;
                line-height: 35px;
                padding: 0 14px;
                background: #F2F2F2;
                margin: 10px 0;
                display: flex;
                justify-content: space-between;
                width: 100%;
                .ant-btn {
                    height: 30px;
                    float: none;
                }

                .anticon {
                    font-size: 14px;
                    margin: 0 10px 0 0;
                }
            }
        }
    }

    .course-section {
        h3 {
            display: flex;
            justify-content: space-between;
            -webkit-box-pack: justify;
            align-items: center;
        }

    }
    .section-down {
        font-size: 22px;
        color: #24A5FE;

        /deep/ .ant-tag-has-color {
            height: 30px;
            line-height: 27px;
            width: 80px;
            text-align: center;
            display: block;
            font-size: 14px;

        }
    }

    .section-down:hover {
        cursor: pointer;
        color: #00CF8C;
    }

    .down-file-p {
        margin-bottom: 8px;
        display: flex;
        justify-content: space-between;
        width: 100%;

        .item-fileName {
            float: left;
            width: 90%;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box; //作为弹性伸缩盒子模型显示。
            -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
            -webkit-line-clamp: 1; //显示的行
        }

        .item-down {
            display: inline-block;
            float: right;
            /*width: 20px;*/
        }

        .item-down:hover {
            cursor: pointer;
            color: #00CF8C;
        }
        span {
            font-size: 13px;
        }


    }
</style>
